import { render } from "./FrisbuySrBlock.vue?vue&type=template&id=bf85db6c&scoped=true"
import script from "./FrisbuySrBlock.vue?vue&type=script&lang=js"
export * from "./FrisbuySrBlock.vue?vue&type=script&lang=js"

import "./FrisbuySrBlock.vue?vue&type=style&index=0&id=bf85db6c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf85db6c"]])

export default __exports__